export default __webpack_public_path__ + "static/general_test-8acceddbbc51de848d1ab8620d956e42.png";